import React from 'react';
import { Button } from '@/components/ui/button';
import {
	AlertDialog,
	AlertDialogContent,
	AlertDialogDescription,
	AlertDialogFooter,
	AlertDialogHeader,
	AlertDialogTitle,
} from '@/components/ui/alert-dialog';
import { apiClient } from '@/lib/api-client';
import { toast } from 'sonner';

interface CancelSubscriptionDialogProps {
	open: boolean;
	onOpenChange: (open: boolean) => void;
	orgId: string;
	onSuccess: () => void;
}

export function CancelSubscriptionDialog({
	open,
	onOpenChange,
	orgId,
	onSuccess,
}: CancelSubscriptionDialogProps) {
	const [loading, setLoading] = React.useState(false);

	const handleCancel = async () => {
		setLoading(true);
		try {
			const res = await apiClient.cancelSubscription(orgId);
			if (res.success) {
				toast.success('Subscription will be canceled at the end of the billing period');
				onSuccess();
				onOpenChange(false);
			} else {
				toast.error('Failed to cancel subscription');
			}
		} catch {
			toast.error('Failed to cancel subscription');
		} finally {
			setLoading(false);
		}
	};

	return (
		<AlertDialog open={open} onOpenChange={onOpenChange}>
			<AlertDialogContent>
				<AlertDialogHeader>
					<AlertDialogTitle>Cancel subscription?</AlertDialogTitle>
					<AlertDialogDescription>
						Your subscription will remain active until the end of the current billing period.
						After that, your organization will be downgraded to the Free plan.
						You can reactivate anytime before the period ends.
					</AlertDialogDescription>
				</AlertDialogHeader>
				<AlertDialogFooter>
					<Button variant="outline" onClick={() => onOpenChange(false)} disabled={loading}>
						Keep subscription
					</Button>
					<Button
						variant="destructive"
						onClick={handleCancel}
						disabled={loading}
					>
						{loading ? 'Canceling...' : 'Cancel subscription'}
					</Button>
				</AlertDialogFooter>
			</AlertDialogContent>
		</AlertDialog>
	);
}
